import { render, staticRenderFns } from "./shopActive.vue?vue&type=template&id=30fb1ba8"
import script from "./shopActive.vue?vue&type=script&lang=js"
export * from "./shopActive.vue?vue&type=script&lang=js"
import style0 from "./shopActive.vue?vue&type=style&index=0&id=30fb1ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports